{
  "skip-to-main-content": "Hoppa till huvudinnehåll",
  "homepage-title": "Boka pass och kurser",
  "homepage-choose-week": "Välj vecka",
  "header-membersapp": "Bokningsportal",
  "home": "Hem",
  "activity": "Aktivitet",
  "all": "Alla",
  "sessions": "Pass",
  "courses": "Kurser",
  "course": "Kurs",
  "events": "Evenemang",
  "yesterday": "I går",
  "today": "Idag",
  "tomorrow": "Imorgon",
  "nav-booking": "Boka",
  "nav-bookings": "Bokningar",
  "nav-tickets": "Biljetter",
  "nav-account": "Konto",
  "desktop-nav-booking": "Boka",
  "desktop-nav-bookings": "Bokningar",
  "desktop-nav-tickets": "Biljetter",
  "desktop-nav-account": "Mitt konto",
  "settings-button-aria": "Öppna inställningar",
  "book-courses-title": "Boka dina simskolekurser",
  "book-sessions-title": "Boka dina pass här",
  "activity-not-bookable": "Ej bokningsbar",
  "activity-locked-out": "Spärrad",
  "activity-not-bookable-description": "Denna aktivitet kan inte bokas för tillället.",
  "activity-bookable-from": "Denna aktivitet är bokningsbar fr.o.m.",
  "back-to-home": "Tillbaka",
  "book-button": "Boka",
  "book-activity": "Boka aktivitet",
  "choose-date": "Välj datum",
  "to-next-week": "Till nästa vecka",
  "to-prev-week": "Till föregående vecka",
  "place": "Plats",
  "places": "platser",
  "left": "kvar",
  "enqueue": "Ställ dig i kö",
  "booking-reference": "Bokningsreferens",
  "participants-in-queue": "Antal deltagare i kö",
  "participants-booked": "bokade",
  "participants-has-booked": "Antal deltagare inbokade",
  "in-queue": "{{queue}} i kö",
  "queue": "Kö",
  "queue-position": "Köplats",
  "queue-description": "Notera att detta är en köbokning och betyder inte att du har fått platsen. Skulle en deltagare avboka kommer du kunna att bekräfta din plats och betala bokningen.",
  "full": "Fullt",
  "choose-occasion": "Välj tillfälle",
  "occasions": "Tillfällen",
  "first-occasion": "Första tillfälle",
  "participants": "Deltagare",
  "participant-already-booked": "Redan inbokad",
  "of": "av",
  "next-session-title": "Nästa tillfälle",
  "next-session-link": "Navigera till nästa tillfälle",
  "next-session-exists": "Nästa tillfälle för detta pass denna vecka är",
  "next-session-empty": "Detta är sista passet av denna aktivitet för veckan, navigera till nästa vecka och kolla där.",
  "statistics-label": "Aktivitet",
  "statistics-description": "Antal personer på anläggningen",
  "choose-managed-title": "Välj deltagare",
  "choose-managed-body": "Välj deltagare till aktiviteten. Om du ska boka in ett barn eller annan anhörig, tryck på \"Ny användare\" för att lägga till dem i din lista.",
  "continue": "Gå vidare",
  "confirm-title": "Bekräfta bokning",
  "slide-confirm": "Dra för att bekräfta",
  "slide-cancel": "Dra för att avboka",
  "booking-completed": "Din bokning är nu gjord",
  "booking-reserved": "Din bokning är nu gjord",
  "booking-confirmation-message": "Tack för din bokning!",
  "booking-failed": "Bokning misslyckades",
  "booking-error-message": "Något gick fel med din bokning. Vänligen försök igen.",
  "booking-full-title": "Denna aktivitet är fullbokad.",
  "booking-full-description": "Du kan ställa dig i kö till aktiviteten. Avbokar en deltagare kan du få den platsen om du är nästa i kö.",
  "booking-full-queue-description-price": "Du har upp till 24 timmar på dig att betala från det att din köbokning accepteras.",
  "booking-full-queue-description-free": "Du kommer bli automatiskt inbokad om en plats blir ledig, håll koll på ett bekräftelsemejl som skickas ut till dig.",
  "toast-pay-booking": "Du har inte betalat din bokning, vänligen betala snarast för att inte förlora din plats!",
  "toast-pay-within": "Du måste betala inom",
  "toast-pay-now": "Betala nu",
  "toast-ticket-activated": "Biljetten är nu aktiverad",
  "toast-user-created": "Användaren är nu skapad!",
  "toast-password-changed": "Ditt lösenord är nu ändrat",
  "toast-user-not-found": "Kunde inte hitta din användare, testa logga ut och in och försök igen.",
  "toast-ticket-not-found": "Kunde inte hitta biljetten, kolla så nummerserien stämmer och försök igen",
  "toast-ticket-not-activable": "Denna biljett behöver inte aktiveras",
  "toast-old-password-incorrect": "Det gamla lösenordet stämmer inte",
  "toast-passwords-incorrect": "Lösenorden stämmer inte överens med varandra",
  "toast-error-password-reuse": "Du kan inte återanvända ett tidigare lösenord.",
  "toast-error-password-capital": "Du måste ha minst en stor bokstav i lösenordet",
  "toast-password-changed-successfully": "Lösenordet är ändrat, du kan nu logga in med ditt nya lösenord.",
  "toast-user-already-booked": "Användaren är redan inbokad på denna aktivitet.",
  "toast-something-error": "Något gick fel, testa igen lite senare!",
  "toast-used-email": "Mejlen är redan registrerad, testa en annan.",
  "toast-invalid-ssn": "Personnumret är felaktigt, kolla antalet siffror och försök igen.",
  "toast-used-ssn": "Personnumret är redan använt, har du redan ett konto kan du logga in istället.",
  "toast-used-ssn-managed": "Personnumret är redan registrerat.",
  "toast-changed-user": "Du har nu bytt användare",
  "toast-changed-photo": "Fotot är nu ändrat",
  "toast-photo-upload-error": "Något gick fel, testa ett annat foto",
  "toast-changed-info": "Användaruppgifterna är nu uppdaterade",
  "toast-logout-success": "Du är nu utloggad",
  "toast-account-created": "Kontot är nu skapat!",
  "toast-error-cancellation-time": "Sista avbokningstid har passerat.",
  "toast-error-user-not-found": "Mejladressen finns inte i systemet",
  "toast-error-user-in-queue": "Deltagaren är redan i kö till denna aktivitet",
  "toast-error-user-max-bookings": "Deltagaren har nått max antal bokningar",
  "toast-cancelled-booking": "Din bokning har avbokats.",
  "toast-reset-mail-success": "Återställningsmejl har skickats till mejladressen",
  "toast-navigated-next-date": "Navigerade till tillfället",
  "loading-spinner-wait": "Vänligen vänta...",
  "no-activities-available": "Inga pass eller kurser tillgängliga för tillfället",
  "no-sessions-available": "Inga pass tillgängliga detta datum",
  "no-courses-available": "Inga kurser tillgängliga för tillfället",
  "no-sessions-available-landing": "Inga bokningsbara pass",
  "no-courses-available-landing": "Inga bokningsbara kurser",
  "no-allotments-available": "Inga evenemang tillgängliga för tillfället",
  "no-allotments-available-landing": "Inga bokningsbara evenemang",
  "no-products-available": "Inga produkter är tillgängliga",
  "need-to-login-title": "Du måste vara inloggad",
  "need-to-login-description": "För att kunna boka pass och kurser måste du vara inloggad.",
  "need-to-login-view-bookings": "Du måste vara inloggad för att se dina bokningar",
  "need-to-login-view-tickets": "Du måste vara inloggad för att se dina biljetter",
  "to-login-page": "Till inloggningssidan",
  "create-account": "Skapa konto",
  "create-account-first-description": "Skapa ett konto i ditt eget namn. Om du ska boka in ditt barn på simskola registrerar du dig själv som ansvarig/målsman. När du väl har loggat in och ska boka, får du möjlighet att ange deltagare och skriver då in barnets namn och personnummer.",
  "create-account-second-title": "Har du problem att registrera dig?",
  "create-account-second-description": "Om ditt personnummer finns inlagt i vårt kundregister sedan tidigare (t ex om du har köpt ett månadskort hos oss) kan du inte registrera dig som ny kund då vi kräver ett unikt personnummer. Kontakta simhallen så hjälper vi dig.",
  "forgot-password": "Glömt lösenord",
  "login": "Logga in",
  "logout": "Logga ut",
  "duration": "Längd",
  "close": "Stäng",
  "close-dialog": "Stäng ruta",
  "booking-page-description": "Här ser du samtliga kommande bokningar som är gjorda. Klicka på bokningarna för att se mer information om dem.",
  "booking-page-your-bookings": "Dina bokningar",
  "booking-page-cancellations": "Avbokningar",
  "no-bookings-found": "Inga bokningar har gjorts än",
  "no-cancellations-found": "Inga avbokningar har gjorts än",
  "show-latest-bookings": "Här visas dina senaste bokningar",
  "cancel": "Avboka",
  "cancelled": "Avbokad",
  "activity-cancelled": "Aktiviteten avbokades",
  "cancellation-failed": "Avbokningen misslyckades",
  "activity-cancel": "Avboka aktivitet",
  "activity-cancel-description": "Du kommer nu att avboka aktiviteten. Notera att detta inte går att ångra.",
  "activity-review-cancellation": "Bekräfta avbokning",
  "day": "dag",
  "days": "dagar",
  "hour": "timme",
  "hours": "timmar",
  "minute": "minut",
  "minutes": "minuter",
  "statistics-people-title": "Aktivitet",
  "statistics-people-description": "Antal personer på anläggningen",
  "statistics-not-visited": "Du har inte besökt oss än",
  "statistics-title": "Dina entréer",
  "statistics-visited-description": "Se vilka månader du oftast besöker oss",
  "latest-notifications": "Senaste händelserna",
  "see-all": "Visa alla",
  "ticket-page-header": "Biljetter",
  "ticket-page-no-tickets": "Inga biljetter hittades",
  "ticket-page-no-active-tickets": "Inga aktiva biljetter hittades",
  "ticket-page-read-more": "Tryck på den biljett du vill scanna eller läsa mer om",
  "ticket-page-last-used": "Senast använd",
  "ticket-page-active": "Giltig",
  "ticket-page-not-valid": "Ogiltig",
  "ticket-page-clips-left": "Klipp kvar",
  "ticket-page-belongs-to": "Tillhör",
  "ticket-valid": "Giltighetstid",
  "ticket-invalid": "Biljetten är ogiltig",
  "ticket-active": "Aktiv",
  "ticket-blocked": "Blockerad",
  "ticket-cancelled": "Spärrad",
  "ticket-not-active": "Inte aktiv",
  "ticket-not-used": "Inte använd än",
  "activate-ticket": "Aktivera biljett",
  "activate-ticket-description": "Om din biljett behöver aktiveras, så kan du göra det här. Har du köpt biljetten i en kassa eller i webshopen aktiveras biljetten oftast vid köpet.",
  "activate-ticket-number-label": "Nummerserie",
  "activate-ticket-number-description": "Kan se ut som t.ex. F3A8014A099133",
  "complete-registration-header": "Slutför registrering",
  "complete-registration-first-description": "För att skapa ditt konto behöver du även ett lösenord. Du har fått ett mejl med en länk där du kan välja lösenordet.",
  "complete-registration-second-description": "När du har satt ett lösenord kan du enkelt logga in och börja boka!",
  "complete-registration-shortcuts": "Genvägar till mejlsidorna",
  "customer-info-header": "Kunduppgifter",
  "customer-info-title": "Redigera kunduppgifter",
  "customer-info-description": "Här kan du se och ändra dina uppgifter",
  "save-customer-info": "Klicka på 'Spara uppgifter' när du är klar.",
  "save-customer-info-multi": "Börja med att välja en användare och klicka på 'Spara uppgifter' när du är klar.",
  "customer-info-select-user": "Välj användare",
  "customer-info-base-info": "Basuppgifter",
  "customer-info-firstname": "Förnamn",
  "customer-info-lastname": "Efternamn",
  "customer-info-email": "Mejladress",
  "customer-info-civic": "Personnummer",
  "customer-info-phone-home": "Telefonnummer (hem)",
  "customer-info-phone-mobile": "Telefonnummer",
  "customer-info-phone-work": "Telefonnummer (arbete)",
  "customer-info-company": "Företag",
  "customer-info-phone-error": "Telefonnumret får bara innehålla siffror och plustecken",
  "customer-info-address": "Adressupgifter",
  "customer-info-address-Generic": "Adress",
  "customer-info-address-Delivery": "Leveransadress",
  "customer-info-address-Invoice": "Fakturaadress",
  "customer-info-street": "Gata",
  "customer-info-street-number": "Nummer",
  "customer-info-city": "Stad",
  "customer-info-postal-code": "Postnummer",
  "customer-info-postal-code-error": "Får bara innehålla siffror och måste vara minst fem siffror",
  "customer-info-country": "Land",
  "customer-info-save": "Spara uppgifter",
  "customer-register": "Registrera",
  "customer-add-user": "Lägg till användare",
  "required-fields-marked-with": "Obligatoriska fält markerade med",
  "purchase-history-title": "Köphistorik",
  "account-logged-out-header": "Du är utloggad",
  "account-logged-out-description": "Logga in för att fortsätta. Du behöver ett konto för att använda bokningssystemet.",
  "account-bookings-title": "Bokningar",
  "account-bookings-description": "Se dina bokningar här",
  "account-tickets-title": "Biljetter",
  "account-tickets-description": "Se dina biljetter här",
  "account-purchase-history-title": "Köphistorik",
  "account-purchase-history-description": "Se dina senaste köp",
  "account-subscription-title": "Abonnemang",
  "account-subscription-description": "Se dina abonnemang",
  "account-subscription-change-card-success": "Betalkortet är ändrat",
  "account-subscription-change-card-error": "Det gick inte att ändra betalkortet, försök igen",
  "account-customer-info-title": "Kunduppgifter",
  "account-activate-ticket-title": "Aktivera biljett",
  "account-activate-ticket-description": "Aktivera din biljett här",
  "account-register-managed-title": "Lägg till användare",
  "account-register-managed-description": "Lägg till användare här",
  "account-photo-title": "Byt foto",
  "account-photo-description": "Ändra ditt foto här",
  "account-password-title": "Byt lösenord",
  "account-password-description": "Ändra ditt lösenord",
  "table-saledate": "Datum",
  "table-receipt": "Kvitto",
  "table-pos": "Kassa",
  "table-total-excl-vat": "Summa exkl. moms",
  "table-total-incl-vat": "Summa",
  "table-price-excl-vat": "Pris exkl. moms",
  "table-price-incl-vat": "Pris",
  "table-actions": "Åtgärder",
  "table-placeholder": "Filtrera kvittonummer",
  "table-columns": "Kolumner",
  "table-not-found": "Inga köp hittades",
  "table-previous": "Föregående",
  "table-next": "Nästa",
  "table-page": "Sida {{pageCount}} av {{maxPageCount}}",
  "table-copy-receipt": "Kopiera kvittonummer",
  "table-show-receipt": "Visa kvitto",
  "table-receipt-description": "Här ser du detaljerna kring ditt köp",
  "table-article": "Artikel",
  "open-menu": "Öppna meny",
  "search-courses": "Sök kurser",
  "search-sessions": "Sök pass",
  "show-inactive": "Visa inaktiverade",
  "show-full": "Visa fullbokade",
  "show-full-aria-on": "Dölj fullbokade",
  "show-full-aria-off": "Visa fullbokade",
  "show-inactive-aria-on": "Dölj inaktiverade",
  "show-inactive-aria-off": "Visa inaktiverade",
  "show-cancelled": "Visa avbrutna",
  "subscription-header": "Mina abonnemang",
  "subscription-description": "Nedan ser du info om dina pågående och avbrutna abonnemang. Tryck på ett abonnemang för mer information och för åtgärder.",
  "subscription-status": "Status",
  "subscription-status-aborted": "Avbruten",
  "subscription-status-chargeandfailed": "Dragning med fel",
  "subscription-status-chargefailed": "Misslyckad dragning",
  "subscription-status-registered-label": "Registrerad",
  "subscription-status-registered-badge": "Åtgärd krävs",
  "subscription-status-registered-successful": "Registrering slutförd",
  "subscription-status-registered": "Registrerad",
  "subscription-status-cancelled": "Avbruten",
  "subscription-status-finalized": "Slutbetald",
  "subscription-status-active": "Aktiv",
  "subscription-status-pay": "Betalning krävs",
  "subscription-status-frozen": "Fryst",
  "subscription-state-aborted-cancelled": "Abonnemanget är avbrutet, du behöver beställa ett nytt abonnemang för att fortätta nyttja vår tjänst.",
  "subscription-state-registered": "Detta abonnemang är inte aktivt. Tryck på nedan länk och genomför första dragningen för att aktivera abonnemanget.",
  "subscription-state-registeredfinalized": "Detta abonnemang är aktivt och första dragning är gjord.",
  "subscription-state-charged": "Dragning har gjorts och abonnemanget är aktivt.",
  "subscription-state-chargedfailed": "Dragning misslyckades, troligen på grund av att det inte fanns pengar på betalkortet, alternativt att kortet är ogiltigt. Abonnemanget är inte aktivt",
  "subscription-state-chargedandfailed": "Dragning misslyckades. Kontakta kundtjänst för hjälp.",
  "subscription-state-cancelled": "Abonnemanget är avbrutet. Du kan fortfarande nyttja abonnemanget den period du har betalt för.",
  "subscription-state-active": "Här kan du se information om ditt abonnemang samt byta betalkort.",
  "subscription-start-date": "Startdatum",
  "subscription-end-date": "Avbrutet datum",
  "subscription-type": "Abonnemangstyp",
  "subscription-payments-done": "Betalda dragningar",
  "subscription-payments": "Dragningar",
  "subscription-last-payment": "Senaste dragningen",
  "subscription-next-payment": "Nästa dragning",
  "subscription-reference": "Referens",
  "subscription-type-fixed": "Fast",
  "subscription-type-ongoing": "Löpande",
  "subscription-pay": "Betala",
  "subscription-cancel": "Avbryt abonnemang",
  "subscription-cancel-confirmation": "För att avbryta abonnemanget, vänligen bekräfta nedan. Detta går inte att ångra!",
  "subscription-change-payment": "Byt betalkort",
  "subscription-cancel-success": "Ditt abonnemang är nu avbrutet",
  "subscription-handle-payment": "Hantera betalning",
  "subscription-handle-payment-description": "Här kan du se betalsätt samt byta betalkort",
  "subscription-handle-payment-active": "Aktivt betalkort",
  "subscription-handle-payment-change": "Byt betalkort",
  "subscription-card-number": "Kortnummer",
  "subscription-card-valid-thru": "Giltighetsdatum, månad/år",
  "subscription-history-charged": "Betald",
  "subscription-history-failed": "Missad",
  "subscription-history-due": "Kommande",
  "subscription-history-cancelled": "Makulerad",
  "subscription-price-per-month": "Pris per månad",
  "subscription-table-title": "Betalhistorik",
  "subscription-table-payment": "Dragning",
  "subscription-table-sum": "Summa",
  "subscription-table-status": "Status",
  "subscription-table-paid": "Betald",
  "confirm": "Bekräfta",
  "add-new-user": "Ny användare",
  "managed-header": "Lägg till användare",
  "managed-description": "Här kan du lägga till fler personer som du vill kunna boka åt, t ex familjemedlemmar.",
  "managed-description-extra": "Om personen redan finns i vårt system (genom ett tidigare köp eller bokning) kan du inte lägga till personen här. Kontakta personal på din lokala anläggning så hjälper vi dig med registreringen.",
  "managed-add-new": "Lägg till ny användare",
  "managed-users": "Användare",
  "managed-click-user-to-edit": "Klicka på en användare för att redigera uppgifter.",
  "managed-edit-user-for": "Redigera uppgifter för {{name}}",
  "managed-add-new-user-header": "Lägg till användare",
  "managed-add-new-user-description": "När du har registrerat t.ex. ditt barn kan du boka in ditt barn på kurser och pass.",
  "photo-header": "Foto",
  "photo-description": "Tänk på att personalen på anläggningen behöver kunna känna igen dig på fotot.",
  "photo-alt": "Foto av",
  "photo-change": "Byt foto",
  "photo-upload-header": "Ladda upp nytt foto",
  "photo-upload-description": "Här kan du ta en nytt foto eller ladda upp foto från din enhet.",
  "photo-change-image": "Välj nytt foto",
  "password-header": "Byt lösenord",
  "password-header-reset": "Återställ lösenord",
  "password-header-reset-title": "Återställ",
  "password-new-description": "Välj ett nytt lösenord till ditt konto. Ditt lösenord blir extra säkert om det innehåller både bokstäver och siffror.",
  "password-description": "Här kan du ändra ditt lösenord. Ange först nuvarande lösenord och sedan ditt nya lösenord.",
  "password-reset-description": "Ange din e-postadress och klicka på skicka för att få ett e-postmeddelande med en länk för att byta lösenord. Tänk på att kolla i skräpposten om du inte får något mejl.",
  "password-old": "Nuvarande lösenord",
  "password-new": "Nytt lösenord",
  "password-confirm-new": "Bekräfta nytt lösenord",
  "password-confirm-change": "Byt lösenord",
  "search-close": "Stäng",
  "search-title": "Sök...",
  "search-placeholder": "Kurser och veckans pass, namn, beskrivning, id...",
  "search-no-results": "Inga resultat hittades",
  "badge-not-paid": "Ej betald",
  "badge-queue": "I kö",
  "badge-cancelled": "Avbokad",
  "badge-paid": "Betald",
  "dark-theme": "Mörkt tema",
  "language-change": "Byt språk",
  "language-change-to": "Byt språk till",
  "language-swedish": "svenska",
  "language-english": "engelska",
  "language-danish": "danska",
  "language-german": "tyska",
  "language-spanish": "spanska",
  "payment": "Betalning",
  "install-app-maybe-later": "Kanske senare",
  "install-app-dont-show-again": "Visa inte igen",
  "install-app-install": "Installera",
  "install-app-our": "Installera vår app",
  "install-app-description": "För bästa upplevelse är det rekommenderat att installera appen, tryck på knappen för att installera.",
  "install-app-description-ios": "Installera vår app genom att trycka på",
  "install-app-description-ios-update": "Uppdatera vår app genom att trycka på",
  "install-app-description-update": "Tack för att du uppdaterar appen! Tryck på knappen och kom igång med bokandet igen. Den gamla appen på hemskärmen kan sedan tas bort.",
  "install-app-confirmation-title": "Är du helt säker?",
  "install-app-confirmation-description": "Du kommer inte att få påminnelse om installation av vår app igen. Skulle du ångra dig kan du trycka på",
  "install-app-confirmation-continue": "och sedan på \"Installera appen\".",
  "install-app-confirmation-continue-firefox": "och sedan på \"Installera\".",
  "install-app-confirmation-samsung-continue-1": "och sedan på",
  "install-app-confirmation-samsung-continue-2": "\"Lägg till sida\" på och tryck sedan på \"Hemskärm\".",
  "install-app-confirmation-safari-continue-1": "scrolla sedan ner och tryck på:",
  "install-app-confirmation-safari-continue-2": "Lägg till på hemskärmen",
  "install-app-samsung-warning-title": "För dig med Samsung Browser",
  "install-app-samsung-warning-description": "Android behandlar alla webbappar som installeras med Samsung Browser som osäkra. Välj att installera ändå eller byt webbläsare för att installera.",
  "form-error-firstname": "Förnamn är obligatoriskt",
  "form-error-firstname-long": "Förnamnet får inte vara längre än 100 tecken",
  "form-error-lastname": "Efternamn är obligatoriskt",
  "form-error-lastname-long": "Efternamnet får inte vara längre än 100 tecken",
  "form-error-mail": "Mejl är obligatoriskt",
  "form-error-mail-invalid": "Ogiltig mejladress",
  "form-error-civic-short": "Personnumret måste innehålla minst 10 siffror",
  "form-error-civic-invalid": "Ogiltigt personnummer",
  "form-error-zip": "Postnummer är obligatoriskt",
  "form-error-zip-invalid": "Ogiltigt postnummer",
  "form-error-password-short": "Lösenordet måste vara minst 5 tecken",
  "form-error-password-long": "Lösenordet får inte vara över 100 tecken",
  "form-error-phone": "Telefonnummer är obligatoriskt",
  "form-error-phone-invalid": "Telefonnumret måste vara mellan 10-15 siffror",
  "form-error-email-invalid": "Ogiltig e-postadress",
  "form-error-email-long": "E-postadressen får inte vara längre än 255 tecken",
  "form-error-phone-long": "Telefonnumret får inte vara längre än 20 tecken",
  "form-error-street-long": "Gatuadressen får inte vara längre än 255 tecken",
  "form-error-street-number-long": "Gatunumret får inte vara längre än 10 tecken",
  "form-error-city-long": "Staden får inte vara längre än 100 tecken",
  "form-error-country-long": "Land får inte vara längre än 100 tecken",
  "form-error-photo-required": "Foto är obligatoriskt",
  "form-error-field-required": "{{field}} är obligatoriskt",
  "form-error-field-invalid": "Felaktigt {{field}}",
  "form-show-old-password": "Visa ditt gamla lösenord på skärmen",
  "form-hide-old-password": "Göm ditt gamla lösenord på skärmen",
  "form-show-password": "Visa ditt nya lösenord på skärmen",
  "form-hide-password": "Göm ditt nya lösenord på skärmen",
  "form-show-verification-password": "Visa ditt nya bekräftelselösenord på skärmen",
  "form-hide-verification-password": "Göm ditt nya bekräftelselösenord på skärmen",
  "form-phone-short": "Telefonnumret är för kort",
  "form-phone-long": "Telefonnumret är för långt",
  "form-phone-invalid": "Använd bara siffror för telefonnumret",
  "cookies-title": "Kakor",
  "cookies-description": "Vi använder nödvändiga kakor på sajten för att den ska fungera som den ska och ge dig den bästa upplevelsen.",
  "cookies-link": "Läs mer om våra kakor",
  "cookies-consent-ok": "Okej",
  "cookies-consent-decline": "Avböj",
  "not-found-title": "Borttappad länk",
  "not-found-description": "Det verkar som att länken du försöker nå är borttappad. Klicka på knappen för att återvända till startsidan.",
  "not-found-button": "Till startsidan",
  "not-found-eyebrow": "Fel · Sidan hittades inte",
  "not-found-heading": "Den här sidan fanns inte",
  "not-found-body": "Den kan ha flyttats, bytt namn eller aldrig ha funnits. Hur som helst håller vi ett öga på den.",
  "not-found-back-home": "Till startsidan",
  "not-found-go-back": "Gå tillbaka",
  "not-found-heading-course": "Den här kursen kunde inte hittas",
  "not-found-body-course": "Kursen kan ha tagits bort eller så är länken felaktig. Prova att bläddra bland våra kurser istället.",
  "not-found-heading-session": "Det här passet kunde inte hittas",
  "not-found-body-session": "Passet kan ha tagits bort eller så är länken felaktig. Prova att bläddra bland våra pass istället.",
  "not-found-heading-allotment": "Det här evenemanget kunde inte hittas",
  "not-found-body-allotment": "Evenemanget kan ha tagits bort eller så är länken felaktig. Prova att bläddra bland våra evenemang istället.",
  "not-found-heading-product": "Den här biljetten kunde inte hittas",
  "not-found-body-product": "Biljetten kan ha tagits bort eller sålt slut, eller så är länken felaktig. Prova att bläddra bland våra biljetter istället.",
  "not-found-heading-articlegroup": "Den här kategorin kunde inte hittas",
  "not-found-body-articlegroup": "Kategorin kan ha tagits bort eller bytt namn, eller så är länken felaktig.",
  "accessibility-title": "Tillgänglighet",
  "offline-title": "Offline",
  "filter-title": "Filtrera",
  "sorting-facility-title": "Anläggning",
  "sorting-tag-title": "Märkning",
  "sorting-showing": "{{count}} anläggningar valda",
  "sorting-showing-tags": "{{count}} märkningar valda",
  "update": "Uppdatera",
  "update-title": "Uppdatera vår app",
  "update-description": "Vår app har uppdaterats och du skulle behöva installera om den. Tryck på knappen nedan för att kopiera länken. Öppna sedan länken i din vanliga webbläsare och installera appen.",
  "update-copy": "Kopiera installationslänken",
  "update-copied": "Kopierade länken",
  "update-finished": "När installationen är färdig kan du fortsätta här i webbläsaren eller öppna appen.",
  "course-detail-title": "{{courseName}} kursinformation",
  "course-detail-description": "Här kan du se information om kursen {{courseName}}, datum och tider, samt boka in dig.",
  "session-detail-title": "{{sessionName}} passinformation",
  "session-detail-description": "Här kan du se information om passet {{sessionName}}, datum och tid, samt boka in dig.",
  "allotment-detail-title": "{{allotmentName}} aktivitetsinformation",
  "allotment-detail-description": "Här kan du se information om aktiviteten {{allotmentName}}, datum och tid, samt boka in dig.",
  "allotments": "Evenemang",
  "products": "Biljetter",
  "ticket": "Biljett",
  "product": "Produkt",
  "overview": "Översikt",
  "description": "Beskrivning",
  "session-information": "Aktivitetsinformation",
  "course-information": "Kursinformation",
  "bookable-from": "Bokningsbar från",
  "number-of-occasions": "Antal tillfällen",
  "number-of-places": "Antal platser",
  "number-of-booked": "Antal bokade",
  "course-id": "Kurs-ID",
  "instructor": "Instruktör",
  "contact": "Kontakt",
  "length": "Längd",
  "choose-participant": "Välj deltagare",
  "create-new": "Skapa ny",
  "participant": "Deltagare",
  "price-group": "Prisgrupp",
  "base": "Bas",
  "price-includes": "Priset inkluderar moms och avgifter",
  "book": "Boka",
  "book-course": "Boka kurs",
  "book-session": "Boka pass",
  "book-allotment": "Boka aktivitet",
  "login-to-book": "Logga in för att boka",
  "persons": "personer",
  "time": "Tid",
  "add-to-cart": "Lägg i varukorgen",
  "cart": "Varukorg",
  "cart-empty": "Din varukorg är tom",
  "cart-total": "Total",
  "cart-checkout": "Gå till kassan",
  "cart-continue-shopping": "Fortsätt handla",
  "cart-open": "Öppna varukorgen",
  "cart-close": "Stäng varukorgen",
  "cart-decrease-quantity": "Minska antal med 1",
  "cart-increase-quantity": "Öka antal med 1",
  "cart-remove-item": "Ta bort",
  "show": "Visa",
  "article-groups": "Övrigt",
  "categories": "Kategorier",
  "our-activities": "Våra aktiviteter",
  "our-activities-description": "Här är våra närmast kommande aktiviteter, du kan också välja att visa alla aktiviteter.",
  "quantity": "Antal",
  "product-detail-title": "{{productName}} produktinformation",
  "product-detail-description": "Här kan du se information om produkten {{productName}}",
  "no-description-available": "Ingen beskrivning tillgänglig",
  "multi-ticket": "Familjebiljett",
  "form-personal-info": "Personliga uppgifter",
  "form-personal-info-description": "Vänligen fyll i uppgifterna nedan för att fortsätta",
  "form-firstname": "Förnamn",
  "form-lastname": "Efternamn",
  "form-email": "E-postadress",
  "form-civic": "Personnummer",
  "form-civic-placeholder": "ÅÅÅÅMMDD-NNNN",
  "form-phone": "Telefonnummer",
  "form-address": "Adress",
  "form-street": "Gata",
  "form-street-number": "Gatunummer",
  "form-zip-code": "Postnummer",
  "form-city": "Stad",
  "form-country": "Land",
  "form-photo": "Foto",
  "form-photo-exceed-size": "Foto överskrider max storlek",
  "form-photo-exceed-size-max-files": "Du kan bara ladda upp ett maximum av {{maxFiles}} filer.",
  "form-invalid-file-type": "Filtypen {{fileType}} är inte acceptad.",
  "upload-file": "Ladda upp fil",
  "uploaded-image": "Uppladdad bild",
  "drop-image-or-browse": "Släpp din bild här eller klicka för att bläddra",
  "max-size": "Max storlek: {{size}} MB",
  "remove-image": "Ta bort bild",
  "crop-close": "Släng",
  "crop": "Beskär",
  "crop-error": "Något gick fel vid beskärning!",
  "profile-image": "Profilbild",
  "image-cropper-alt": "Bildbeskärare",
  "loading": "Laddar...",
  "settings": "Inställningar",
  "settings-description": "Ändra ditt språk, valuta och tema",
  "language": "Språk",
  "currency": "Valuta",
  "theme": "Tema",
  "change-language": "Ändra språk",
  "change-language-to": "Ändra språk till",
  "choose-theme": "Välj tema",
  "theme-light": "Ljust",
  "theme-dark": "Mörkt",
  "theme-system": "System",
  "close-settings": "Stäng inställningar",
  "current-language": "Nuvarande språk",
  "flag": "flagga",
  "out-of-stock": "Slut i lager",
  "product-type": "Produkttyp",
  "regular-products": "Vanliga produkter",
  "gift-certificate": "Presentkort",
  "gift-certificates": "Presentkort",
  "multi-tickets": "Flerbiljetter",
  "packages": "Paket",
  "personal-tickets": "Personliga biljetter",
  "personal-ticket-fill-out-fields": "Fyll i uppgifter för personen som ska använda biljetten",
  "category": "Kategori",
  "sizes": "Storlekar",
  "no-products-found": "Inga produkter matchar de valda filtren.",
  "results": "resultat",
  "filters": "Filtrering",
  "search-products": "Sök produkter...",
  "clear-search": "Rensa sökfält",
  "sort-by": "Sortera efter",
  "name-ascending": "Namn A-Ö",
  "name-descending": "Namn Ö-A",
  "price-ascending": "Lägst pris",
  "price-descending": "Högst pris",
  "search-label": "Sök",
  "search-allotments": "Sök aktiviteter...",
  "location": "Anläggning",
  "all-locations": "Alla anläggningar",
  "date-range": "Från- och till datum",
  "no-allotments-found": "Inga aktiviteter hittades",
  "time-ascending": "Tid (stigande)",
  "time-descending": "Tid (fallande)",
  "date-not-available": "Datum inte tillgängligt",
  "go-to-prev-month": "Gå till föregående månad {{monthName}}",
  "go-to-next-month": "Gå till nästa månad {{monthName}}",
  "go-to-prev-week": "Gå till föregående vecka {{previousWeek}}",
  "go-to-next-week": "Gå till nästa vecka {{nextWeek}}",
  "select-date": "Välj datum",
  "select-tickets": "Välj biljetter",
  "exceeds-capacity": "Överskrider kapacitet",
  "spots-remaining": "platser kvar",
  "pick-date": "Välj datum",
  "allotment-information": "Aktivitetsinformation",
  "allotment-id": "Aktivitets-ID",
  "available-courses": "Tillgängliga kurser",
  "available-sessions": "Tillgängliga pass",
  "available-occasions": "Tillgängliga tillfällen",
  "places-remaining": "Platser kvar",
  "date": "Datum",
  "change-card-view-to": "Byt till {{cardViewType}}",
  "grid-view": "rutnätsvy",
  "list-view": "listvy",
  "abort": "Avbryt",
  "invalid-additional-field": "Ogiltigt format för {{fieldName}}",
  "select-tickets-per-category": "Välj antal biljetter per kategori",
  "free-of-charge": "Gratis",
  "places-left": "{{count}} platser kvar",
  "enter-additional-information": "Ange ytterligare information",
  "enter-field": "Ange {{field}}",
  "could-not-find-activity": "Kunde inte hitta aktiviteten",
  "could-not-find-product": "Kunde inte hitta produkten",
  "move-occasions-title": "Omboka biljetter",
  "move-occasions-back-to-bookings": "Tillbaka till mina bokningar",
  "move-occasions-step-of": "Steg {{current}} av {{total}} — {{label}}",
  "move-occasions-step-intro": "Introduktion",
  "move-occasions-step-booking": "Välj bokning",
  "move-occasions-step-datetime": "Datum & tid",
  "move-occasions-step-confirm": "Bekräfta",
  "move-occasions-step-code": "Kod",
  "move-occasions-step-done": "Klart",
  "move-occasions-choose-title": "Välj bokning att omboka",
  "move-occasions-choose-subtitle": "Vi hittade följande bokningar på ditt konto.",
  "move-occasions-datetime-title": "Välj nytt datum och tid",
  "move-occasions-choose-time": "Välj tid",
  "move-occasions-time-helper": "Genomstrukna tider är fullbokade.",
  "move-occasions-confirm-title": "Bekräfta din ombokning",
  "move-occasions-confirm-helper": "Kontrollera uppgifterna innan du bekräftar.",
  "move-occasions-label-activity": "Aktivitet",
  "move-occasions-label-current": "Ordinarie bokning",
  "move-occasions-label-new": "Ombokas till",
  "move-occasions-label-quantity": "Antal biljetter",
  "move-occasions-otp-title": "Bekräfta med PIN-kod",
  "move-occasions-otp-subtitle": "Ange din fyrsiffriga kod för att bekräfta ombokningen. PIN-koden finns i bokningens bekräftelsemejl.",
  "move-occasions-otp-label": "Fyrsiffrig bekräftelsekod",
  "move-occasions-success-title": "Din ombokning är klar",
  "move-occasions-success-summary": "{{title}} är nu ombokad till {{dateTime}}, {{qty}} {{unit}}.",
  "move-occasions-next": "Nästa",
  "move-occasions-back": "Tillbaka",
  "move-occasions-continue": "Fortsätt",
  "move-occasions-submit": "Bekräfta ombokning",
  "move-occasions-to-bookings": "Tillbaka till bokningssidan",
  "move-occasions-ticket": "biljett",
  "move-occasions-tickets": "biljetter",
  "move-occasions-loading": "Laddar…",
  "move-occasions-no-bookings": "Inga ombokningsbara bokningar hittades.",
  "move-occasions-error-missing-token": "Kunde inte hitta bokningen, kopiera hela länken i bekräftelsemejlet och försök igen",
  "move-occasions-error-bad-token": "Kunde inte hitta biljetterna, testa kopiera hela länken i bekräftelsemejlet och försök igen",
  "move-occasions-error-illegal-pin": "Fel PIN-kod, skriv in korrekt kod och försök igen",
  "move-occasions-error-no-occasions": "Finns inget tillfälle att flytta från",
  "move-occasions-error-too-close": "Du har valt ett tillfälle som ligger för nära ditt ursprungliga, välj ett längre fram och försök igen",
  "move-occasions-error-invalid-parameter": "Något gick fel, testa ladda om webbsidan och försök igen",
  "move-occasions-error-api": "Något gick fel, testa ladda om webbsidan och försök igen",
  "cookies-policy-title": "Användning av kakor",
  "cookies-what-are-cookies": "Vad är kakor (cookies)?",
  "cookies-what-are-cookies-description": "Kakor är små textfiler som sparas i din webbläsare när du besöker webbplatsen. Vi använder kakor för att webbplatsen ska fungera optimalt, till exempel för att hålla dig inloggad på ditt användarkonto, lägga till artiklar i din varukorg, eller byta språk.",
  "cookies-manage-cookies-in-your-browser": "Hur du hanterar kakor",
  "cookies-manage-cookies-in-your-browser-description": "Om du inte vill att kakor lagras på din dator kan du stänga av funktionen under Inställningar i din webbläsare. Det kan dock leda till att vissa funktioner på denna webbplats inte fungerar som de ska. ",
  "cookies-our-cookies": "Vilka typer av kakor använder vi?",
  "cookies-our-cookies-description": "Det finns olika typer av kakor, men vår webbshop använder enbart nödvändiga kakor. Dessa kakor behöver inte ditt samtyckte utan krävs för att kunna använda webbshopen.",
  "cookies-our-cookies-analytics-desc": "Det finns olika typer av kakor. Vi använder oss av nödvändiga, analytiska samt marknadsföringskakor. Du kan inte neka användandet av nödvändiga kakor (de krävs för att kunna använda webbplatsen), men resterande kakor behöver vi ditt godkännande för att samla in. Du kan alltid blockera kakor för marknadsföring utan att det påverkar funktionerna på webbplatsen.",
  "cookies-names": "Namn",
  "cookies-purpose": "Syfte",
  "cookies-storage-time": "Lagringstid",
  "cookies-save-your-culture": "Sparar ditt val av språk och regional inställning (t.ex. sv-SE).",
  "cookies-session-or-until-you-change-language": "Session eller tills du byter språk",
  "cookies-language-setting-used-by-translation-system": "Språkinställning som används av översättningssystemet, synkas med",
  "cookies-save-currency": "Sparar vilken valuta priser ska visas i.",
  "cookies-save-currency-description": "Session eller tills du byter valuta",
  "cookies-save-saleid": "Kopplar din webbläsare till pågående kundvagn/bokning så att varor och biljetter finns kvar mellan sidvisningar.",
  "cookies-save-saleid-description": "Session (raderas när köpet avslutas eller kundvagnen nollställs)",
  "cookies-save-membersapp-consent": "Kommer ihåg att du tagit del av informationen om cookies i bannern längst ned på sidan.",
  "cookies-one-year": "1 år",
  "cookies-save-membersapp-theme": "Sparar ditt val av ljust, mörkt eller systemets tema."
}
